import { ClickableText } from "@components/clickable/Clickable.styles";
import styled from "styled-components";

import Clickable from "../../components/clickable";
import { T_PLAIN_big, T_TITLE_2 } from "../../global.style";
import { VIEW_PADDING_VALUE } from "../../views/View.styles";

export const StyledVatSubmissionDetail = styled.div`
    padding-bottom: ${VIEW_PADDING_VALUE}px;
    ${T_PLAIN_big};
`;

export const StyledHeading = styled.h2`
    ${T_TITLE_2};
    display: flex;
    align-items: center;
    margin-bottom: 16px;
`;

export const StyledParagraph = styled.p`
    ${T_PLAIN_big};
    margin-bottom: 17px;
`;

export const HeaderSubtitle = styled.div`
    ${T_TITLE_2};
`;

export const LinksGrid = styled.div<{columnGap?: string, $marginBottom?: string, $marginTop?: string}>`
    width: fit-content;
    margin-bottom: ${props => props.$marginBottom ?? '24px'};
    ${props => props.$marginTop ? `margin-top: ${props.$marginTop};` : ''};
    ${T_PLAIN_big};
    display: flex;
    gap: 25px;
    ${ClickableText} {
        white-space: nowrap;
    }
`;

export const ClickableWrapper = styled.div`
    display: flex;
    gap: 30px;
    margin-bottom: 30px;
`;

export const DocumentCountWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const ClickableStyled = styled(Clickable)`
    display: inline-flex;
    align-items: center;

    & svg {
        margin-left: 5px;
    }
`;

export const TableWrapperStyled = styled.div`
    margin-bottom: 42px;
`;

export const CustomFormWrapper = styled.div`
    padding-bottom: 38px; // todo: how much padding??
`;

export const CancelReapplyWrapper = styled.div`
    margin-top: 32px;
`;

export const SwitchTableRowWrapper = styled.div`
    padding-right: 10px;
`;